import React, { Fragment, useState } from 'react';

import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AssignmentIcon from '@material-ui/icons/Assignment';


const ReactTableActions = ({ data }) => {
  //console.log(data); 
 
  

return (<Fragment>
  <td role="cell">
    {data.original.perfil === "10" || data.original.perfil === "11" ? null : (
      <Tooltip title="Procedimiento">
        <IconButton aria-label="launch"
          style={{ padding: 2 }}
          >
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
    )}
    
    <Tooltip title="Ver Historia">
      <IconButton aria-label="launch"
        style={{ padding: 2 }}
        onClick={() => {
          
        }}>
        <LaunchIcon />
      </IconButton>
    </Tooltip>   
    {/*
    <Tooltip title="Ver Historia Ips">
      <IconButton aria-label="launch"
        style={{ padding: 2 }}
        onClick={() => {
          history.push({
            pathname: process.env.PUBLIC_URL + '/pages/clinic-history-ips',
            state: { data: data.original }
          });
        }}>
        <LaunchIcon />
      </IconButton>

      </Tooltip>*/}   
  </td>
</Fragment>)
}

export default ReactTableActions;